import React, { Component } from 'react'
import TypeAheadContainer from '@pcln/typeahead'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { typeaheadApiRequest } from '../../services/typeahead'
import { nearbyAirportApiRequest } from '../../services/nearbyAirport'
import noop from '../../lib/noop'
import formatDisplayValue from './formatDisplayValue'

const FlightsTypeahead = styled(TypeAheadContainer)`
  div[data-test='dropdown-item'] {
    max-height: 60px;
  }
`

class FlyLocationTypeahead extends Component {
  constructor(props) {
    super(props)
    this.state = {
      typeaheadItems: [],
    }
  }

  openDropDown = (value) => {
    this.onTypeAheadChange(value)
  }

  onTypeAheadChange = (e) => {
    const value = get(e, 'target.value', '')
    const updatedValue = value.split(', ')[0]
    if (value && value.length > 0) {
      const apiRequest = this.props.showNearbyAirports ? nearbyAirportApiRequest : typeaheadApiRequest
      apiRequest(updatedValue).then(this.apiRequestHandler)
    }
  }

  apiRequestHandler = (results) => {
    // istanbul ignore else
    if (Array.isArray(results)) {
      this.setState({
        typeaheadItems: results.map((item) => ({
          ...item,
          content: item.itemName,
        })),
      })
    }
  }

  render() {
    const initialValue = formatDisplayValue(this.props)

    return (
      <FlightsTypeahead
        className={this.props.className}
        id={this.props.id}
        onItemSelection={this.props.onChange}
        onTypeAheadChange={this.onTypeAheadChange}
        icon={this.props.icon}
        dropdownOpen={false}
        label={null}
        errorMessage={this.props.errorMessage}
        placeholder={this.props.placeholder}
        initialValue={initialValue}
        type={'text'}
        dropdownItems={this.state.typeaheadItems}
        onInputClick={this.openDropDown}
        focusInputOnLabelClick
        airportCode={this.props.airportCode}
        clearInputOnClick={true}
        allowEmptySelection={false}
        refillPreviousTypeaheadWhenEmpty={true}
        iconMap={this.props.iconMap}
        showNearbyAirports={this.props.showNearbyAirports}
        borderRadius={'lg'}
      />
    )
  }
}

FlyLocationTypeahead.defaultProps = {
  airports: {},
  onChange: noop,
  placeholder: '',
}

FlyLocationTypeahead.propTypes = {
  icon: PropTypes.node,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  airportCode: PropTypes.string,
  errorMessage: PropTypes.string,
  airports: PropTypes.object,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  iconMap: PropTypes.object,
  showNearbyAirports: PropTypes.bool,
}

export default FlyLocationTypeahead
